import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  TextField,
  Grid,
  Typography,
  Card,
  InputLabel,
  Box,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Stack,
  CircularProgress,
  Alert,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  Switch,
  IconButton,
  Chip,
  ListSubheader,
} from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@mui/styles';
import MDButton from 'components/MDButton';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAIPrompt, fetchCategories, openSnackbar, uploadProductImage } from '../../redux/slices/common';
import { addProduct, createProductBatch, deleteProduct, deleteProductBatch, fetchProductInstructions, updateProduct, updateProductBatch } from '../../redux/slices/products';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import BatchTable from './batch';
import InventroyTable from './inventory';
import { productValidations } from 'validations/product';
import { isEmptyObject } from 'utilities/common';
import ProductTerpenoids from './productTerpenoids';
import AddProductTerpenoid from './productTerpenoids/addProductTerpenoid';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import { batchValidation } from 'validations/batch';
import { DatePicker } from '@mui/x-date-pickers';
import CalendarIcon from 'common/customIcons/calendar';
import dayjs from 'dayjs';
import { AccountCircle } from '@mui/icons-material';
import CommonQuillEditor from 'common/editor';
import { grey } from '@mui/material/colors';
import { isNumber } from 'utilities/common';
import ImageDragger from 'common/imageDragger';
import ProductActivityLogs from './ProductActivityLogs';
import { slugRegex } from 'utilities/common';
import AngleRightIcon from 'common/customIcons/angle_right';
import DeleteIcon from 'common/customIcons/delete';
import { getTagListingAPI, deleteProductTagAPI } from '../../redux/apis/products';
import { fetchProductMainCategories, fetchWebCategories } from '../../redux/slices/category';
import { productTypesPrompt } from 'prompt';
import SmartToyIcon from '@mui/icons-material/SmartToy'; // AI robot icon
import { convertAndExtractMeta } from 'utilities/common';
import StiloForm from 'components/strain/stiloForm';
import { generateSku } from 'utilities/common';

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(4),
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
}));

const initialState = {
  productId: '', // You might generate this automatically
  productName: '',
  productImages: [],
  status: 'active',
  isSalePrice: false,
  unitPrice: 0,
  salePrice: '',
  categoryName: '',
  brandName: '',
  createdBy: '',
  tags: [],
  strainSlug: '',
  strainType: '',
  infoEffects: [],
  categoryId: '',
  sku: '',
  brandDescription: '',
  productDescription: '',
  purchaseDate: '',
  uniqueNumber: '',
  expirationDate: null,
  batchStatus: 'active',
  trackingSystem: '',
  purchaseQuantity: '',
  currentQuantity: '',
  unitCost: '',
  thcUnit: '',
  thcValue: '',
  productWeightUnit: '',
  productWeightValue: '',
  heading: '',
  ingredientStatus: false,
  ingredients: '',
  instructionStatus: false,
  instructions: '',
  // isBestSeller: false,
  // isCustFav: false,
  // isFeatured: false
};

const AddProductForm = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mainCategories = {} } = useSelector(state => state.category);
  const { infoEffectData = [], categoriesData, isUploading = false } = useSelector(state => state.common);
  const { singleProduct = {}, loading = false, isUpdating } = useSelector(state => state.products);
  const { user } = useSelector(state => state.auth);
  const { brandsData = {} } = useSelector(state => state.brands);
  const [currentTab, setCurrentTab] = useState('products');
  const { productId = '' } = useParams();
  const [isBatchAddOpen, setIsBatchAddOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const { search } = useLocation();
  const [editBatch, setEditBatch] = useState({});
  const [editTerpenoid, setEditTerpenoid] = useState({});

  const [isTerpeneAddOpen, setIsTerpeneAddOpen] = useState(false);

  const [formData, setFormData] = useState({
    productId: '', // You might generate this automatically
    productName: '',
    productImages: [],
    status: 'active',
    isSalePrice: false,
    unitPrice: 0,
    salePrice: '',
    categoryName: '',
    brandName: '',
    createdBy: user?.name || '',
    tags: [],
    strainSlug: '',
    strainType: '',
    infoEffects: [],
    categoryId: '',
    sku: '',
    brandDescription: '',
    productDescription: '',
    purchaseDate: undefined,
    uniqueNumber: '',
    expirationDate: null,
    trackingSystem: '',
    purchaseQuantity: '',
    currentQuantity: '',
    unitCost: '',
    batchStatus: 'active',
    ingredientStatus: false,
    ingredients: '',
    instructionStatus: false,
    instructions: '',
    metaTitle: '',
    metaDescription: '',
  });
  const [productSlugData, setProductSlugData] = useState("")
  const [isProductSlug, setIsProductSlugData] = useState(false)
  const [tagList, setTagList] = useState([]);
  const [tagSearch, setTagSearch] = useState('');

  const fetchTagListing = () => {
    getTagListingAPI().then(res => {
      const data = res?.tags;
      const list = Array.isArray(data) ? data : data?.tags ?? data?.data ?? [];
      setTagList(list.map(t => (typeof t === 'string' ? t : t?.tag ?? t?.name ?? '')).filter(Boolean));
    }).catch(() => {});
  };
console.log("tagList",tagList);

  useEffect(() => { fetchTagListing(); }, []);

  const handleAddNewTagModal = () => {
    dispatch(openCustomModalDialog({ modal: 'ADD_NEW_TAG_MODAL', modalData: { fetchTagListing } }));
  };

  const tagDeleteHandler = (tag) => {
    dispatch(setModalLoader(true));
    deleteProductTagAPI(tag).then(() => {
      dispatch(closeCustomModalDialog());
      fetchTagListing();
      setFormData(prev => ({ ...prev, tags: prev.tags.filter(t => t !== tag) }));
    }).catch(() => {
      dispatch(setModalLoader(false));
    });
  };

  const removeImageHandler = (productIdx = '') => {
    let productImages = [...formData?.productImages];
    let newProductImages = productImages?.filter(((product, _productIdx) => _productIdx !== productIdx));
    setFormData({ ...formData, productImages: newProductImages });

  };


  // const handleChangeSlug = (e) => {
  //   setIsProductSlugData(true)
  //   setProductSlugData(e.target.value);
  // };
  const handleChangeSlug = (e) => {
    const value = e.target.value;
    setIsProductSlugData(true);
    setProductSlugData(slugRegex(value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { isValid, errors } = productValidations({ ...formData, isStilo: true });
    setErrors(errors);
    if (!isValid) return;
    // Add logic here to handle form submission
    let payload = { ...formData, updatedBy: user?.name };
    let customWeight = formData.productWeightValue && formData?.productWeightUnit ? `${formData.productWeightValue}${formData?.productWeightUnit}` : '';
    let thcData = formData.thcValue && formData?.thcUnit ? `${formData.thcValue}${formData?.thcUnit}` : '';
    payload = {
      ...payload,
      salePrice: +payload.salePrice,
      unitPrice: +payload.unitPrice,
      unitCost: +payload.unitPrice,
      customWeight,
      thcData,
      productSlug: `${productSlugData}-${productId}`
    };
    // if (isProductSlug) {
    //   payload.productSlug = `${productSlugData}-${productId}`
    // }

    delete payload.productWeightValue;
    delete payload.productWeightUnit;
    delete payload.thcValue;
    delete payload.thcUnit;

    if (productId) {
      dispatch(updateProduct({ data: payload, productId })).unwrap().then((res) => {
        showError(res?.message, 'success');
        navigate(`/products/details/${productId}?filter=products`);
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    } else {
      dispatch(addProduct(payload)).unwrap().then((res) => {
        showError(res?.message, 'success');
        navigate(`/products/details/${res?.productData?.productId}?filter=products`);
      }).catch((err) => {
        showError(err?.message, 'error');
      });
    }
  };

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const handleInstructions = (value) => {
    dispatch(fetchProductInstructions({ categoryName: value })).unwrap()
      .then(res => {
        setFormData((prevData) => ({ ...prevData, instructions: res?.instruction }));
      });
  };

  const handleBatchProductSubmit = (e) => {
    e.preventDefault();
    const { purchaseDate, uniqueNumber, expirationDate, batchStatus, trackingSystem, purchaseQuantity, currentQuantity, unitCost } = formData;

    const { isValid = false, errors = {} } = batchValidation({ purchaseDate, uniqueNumber, expirationDate, batchStatus, trackingSystem, purchaseQuantity, currentQuantity, unitCost });

    if (!isValid) {
      setErrors(errors);
      return;
    }
    setErrors({});
    // Prepare payload
    const payload = {
      purchaseDate: dayjs(purchaseDate).valueOf(),
      uniqueNumber,
      expirationDate: expirationDate ? dayjs(expirationDate).valueOf() : null,
      status: batchStatus,
      trackingSystem,
      purchaseQuantity: +purchaseQuantity,
      currentQuantity: +currentQuantity,
      unitCost: +unitCost,
      updatedBy: user?.name,
    };

    if (!isEmptyObject(editBatch)) {
      // If editing an existing batch
      const { productBatchId } = editBatch;

      dispatch(updateProductBatch({ data: { ...payload, productId }, productBatchId }))
        .unwrap()
        .then((res) => {
          showError(res?.message, 'success');
          batchHandler();
          setFormData({ ...formData, purchaseDate: '', uniqueNumber: '', expirationDate: null, batchStatus: '', trackingSystem: '', purchaseQuantity: '', currentQuantity: '', unitCost: '' });
        }).catch((err) => {
          showError(err?.message, 'error');
        });
    } else {
      // If creating a new batch
      dispatch(createProductBatch({ ...payload, productId }))
        .unwrap()
        .then((res) => {
          showError(res?.message, 'success');
          batchHandler();
        }).catch((err) => {
          showError(err?.message, 'error');
        });
    }
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'productWeightValue' && !formData?.productWeightUnit) {
      setErrors({ ...errors, productWeightUnit: 'Please select product weight unit first' });
      return;
    };
    if (name === 'thcValue' && !formData?.thcUnit) {
      setErrors({ ...errors, thcUnit: 'Please select product thc unit first' });
      return;
    }
    if ((name === 'currentQuantity' && value && !isNumber(value)) || (name === 'purchaseQuantity' && value && !isNumber(value))) return;
    if ((name === 'thcValue' && Math.sign(value) === -1) || (name === 'productWeightValue' && Math.sign(value) === -1) || (name === 'salePrice' && Math.sign(value) === -1) || (name === 'unitPrice' && Math.sign(value) === -1) || (name === 'unitCost' && Math.sign(value) === -1)) return;
    if (name === 'productWeightValue' && value >= 100000) return;
    if (name === 'thcValue' && formData?.thcUnit === '%' && value > 100) return;
    if (name === 'thcValue' && formData?.thcUnit === 'mg' && value >= 100000) return;

    if (name === 'categoryName') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      handleInstructions(value);
    }

    let errorObj = { ...errors };
    delete errorObj[name];
    setErrors({ ...errorObj });
    if (name === 'productWeightUnit') {
      setFormData({ ...formData, productWeightValue: '', productWeightUnit: value });
      return;
    }
    if (name === 'thcUnit') {
      setFormData({ ...formData, thcValue: '', thcUnit: value });
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));

  };

  const convertHtmlToText = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };

  const META_FIELD_VALIDATION_ERROR_MSG =
    "Product Name, Category Name, Brand Name, Strain Type, Product Weight (Value & Unit), and THC (Value & Unit) are required.";
  const META_FIELD_ACCESSORIES_VALIDATION_ERROR_MSG = 'Product Name, Category Name, Brand Name are required.'

  const isAllowProductUpload = useMemo(() => {
    return formData?.productName && formData?.brandName && formData?.categoryName ? true : false;
  }, [formData]);

  useEffect(() => {
    if (!isAllowProductUpload) {
      setErrors({ ...errors, productImages: 'Please add product name , brand name and category name first' });
    } else {
      setErrors({ ...errors, productImages: '' });
    }
  }, [isAllowProductUpload]);

  const handleModalImage = (type, data, index) => {
    dispatch(openCustomModalDialog({
      modal: 'IMAGE_MODAL_SEO',
      modalData: {
        imageContent: type, data, index, fileMediaHandler
      }
    }))
  }

  const fileMediaHandler = (mediaData, imageContent, index) => {
  }

  const productImageUploadHandler = async (e) => {
    if (e.target.files.length) {
      const file = e.target.files[0];


      // Check file size (2 MB = 2 * 1024 * 1024 bytes)
      const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
      if (file.size > MAX_FILE_SIZE) {
        showError('Image size should not exceed 2 MB', 'error');
        return; // Exit the function if file is too large
      }
      const body = new FormData();
      body.append('filePath', file);
      body.append('productName', formData?.productName);
      body.append('categoryName', formData?.categoryName);
      body.append('brandName', formData?.brandName);
      dispatch(uploadProductImage(body)).unwrap().then((res => {
        const data = {
          alt: "",
          title: file?.name,
          description: "",
          url: res.fileUrl

        }
        // handleModalImage('productImage', data)

        let newErrors = { ...errors };
        delete newErrors.productImages;
        setErrors(newErrors);
        setFormData({ ...formData, productImages: [...formData.productImages, res.fileUrl] });
      })).catch((err) => {
        showError(err?.message, 'error');
      });
    }

  };
  const batchHandler = () => {
    setFormData({ ...formData, purchaseDate: '', uniqueNumber: '', expirationDate: null, batchStatus: 'active', trackingSystem: '', purchaseQuantity: '', currentQuantity: '', unitCost: '' });
    setEditBatch({});
    setErrors({});
    setIsBatchAddOpen(!isBatchAddOpen);
  };

  const deleteBatchHandler = (productIds) => {
    dispatch(deleteProductBatch(productIds)).unwrap().then(() => {
      dispatch(closeCustomModalDialog());
      batchHandler();
    }).catch(() => { });
  };

  const terpenoidHandler = () => {
    setIsTerpeneAddOpen(!isTerpeneAddOpen);
  };

  const editBatchHandler = (editData) => {
    setEditBatch(editData);
  };

  const editTerpenoidHandler = (editData) => {
    setEditTerpenoid(editData);
    terpenoidHandler();
  };

  const deleteHandler = () => {
    dispatch(setModalLoader(true));
    dispatch(deleteProduct(productId)).unwrap().then((res) => {
      showError(res?.message, 'success');
      dispatch(closeCustomModalDialog());
      navigate('/products');
    }).catch((err) => {
      dispatch(setModalLoader(false));
      showError(err?.message, 'error');
    });
  };

  useEffect(() => {
    dispatch(fetchCategories({ skip: 0, limit: 1000, userType: 'admin' }));
    dispatch(fetchProductMainCategories({ skip: 0, limit: 1000 }));

  }, []);


  useEffect(() => {
    if (!loading && !isEmptyObject(singleProduct?.productDetails)) {
      if (singleProduct?.productDetails?.productSlug) {
        const parts = singleProduct?.productDetails?.productSlug.split('-');
        const updatedSlug = parts.slice(0, -1).join('-');
        setProductSlugData(updatedSlug);
      }

      let payload = Object.keys(initialState)?.reduce((acc, curr) => {
        return acc = { ...acc, [curr]: singleProduct?.productDetails[curr] };
      }, {});
      const { customWeight, thcData = '' } = singleProduct.productDetails;
      if (customWeight) {
        const customWeightValue = customWeight.includes('mg') ? customWeight?.split('mg')[0] : customWeight.includes('g') ? customWeight?.split('g')[0] : customWeight;
        payload = { ...payload, productWeightValue: customWeightValue, productWeightUnit: customWeight?.includes('mg') ? 'mg' : 'g' };
      }
      if (thcData) {
        const thcDataValue = thcData.includes('%') ? thcData?.split('%')[0] : thcData.includes('mg') ? thcData?.split('mg')[0] : thcData;
        payload = { ...payload, thcValue: thcDataValue, thcUnit: thcData?.includes('%') ? '%' : 'mg' };
      }
      setFormData({ ...payload, ...singleProduct?.productDetails?.seoData, heading: singleProduct?.productDetails?.seoData?.heading, createdBy: singleProduct?.productDetails?.createdBy ? singleProduct?.productDetails?.createdBy : user?.name });
    }
  }, [singleProduct?.productDetails, loading]);


  useEffect(() => {
    if (!isEmptyObject(editBatch)) {
      const { purchaseDate, uniqueNumber, expirationDate, trackingSystem, purchaseQuantity, status, currentQuantity, unitCost } = editBatch || {};
      setFormData({ ...formData, ... { purchaseDate: dayjs(purchaseDate), uniqueNumber, expirationDate: expirationDate ? dayjs(expirationDate) : null, batchStatus: status, trackingSystem, purchaseQuantity, currentQuantity, unitCost } });
    }
  }, [editBatch]);

  useEffect(() => {
    if (search) {
      setCurrentTab(search?.split('=')[1]);
    }
  }, [search]);
  useEffect(() => {
    setEditBatch({});
    setIsBatchAddOpen(false);
    setIsTerpeneAddOpen(false);
    setEditTerpenoid({});
  }, [currentTab]);

  const circularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    position: 'absolute'
  };


  useEffect(() => {
    if (user?.name) {
      setFormData({ ...formData, createdBy: formData?.createdBy ? formData?.createdBy : user?.name });
    }
  }, [user?.name]);

  const handleToggle = (e) => {
    setFormData({
      ...formData,
      categoryType: e.target?.checked ? 'Cannabis' : 'Non-Cannabis'
    });
  }

  useEffect(() => {
    dispatch(fetchWebCategories({ skip: 0, limit: 100, userType: 'admin' }));
  }, []);

  const [selectedCategory, setSelectedCategory] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const [isPromptLoading, setPromptIsLoading] = useState(false)
  const handleChangeee = (event) => {
    setSelectedCategory(event.target.value);
  };

  const [response, setResponse] = useState("");

  const mainWebCategoryName = useMemo(() => {
    if (!formData?.categoryName || !mainCategories) return '';
    const mainCategory = mainCategories?.result?.find(category => category?.categoryName === formData?.categoryName
    );
    return mainCategory?.webCategoryName || '';
  }, [formData?.categoryName, mainCategories]);

  const mainCategoryType = useMemo(() => {
    if (!formData?.categoryName || !mainCategories) return '';
    const mainCategory = mainCategories?.result?.find(category => category?.categoryName === formData?.categoryName
    );
    return mainCategory?.categoryType || '';
  }, [formData?.categoryName, mainCategories]);


  const handleGenerate = useCallback(async () => {
    if (!mainWebCategoryName) {
      return;
    }

    setPromptIsLoading(true);
    setFormData(prev => ({
      ...prev,
      productDescription: '',
      metaTitle: '',
      metaDescription: ''
    }));

    try {
      const categoryPromptFunction = productTypesPrompt[mainWebCategoryName?.toLowerCase()];

      // if (!categoryPrompt) {
      //   return;
      // }
      if (!categoryPromptFunction) {
        return;
      }

      const completePrompt = categoryPromptFunction(promptDataRef.current);
      const payload = { prompt: completePrompt };

      const res = await fetch(`${process.env.REACT_APP_STILO_API_BASE_URL}/api/v1/generate/description`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_AUTH_KEY
        },
      });

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let fullContent = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        fullContent += chunk;

        // Optional: real-time update


        const finalResult = convertAndExtractMeta(fullContent);
        setFormData((prev) => ({
          ...prev,
          productDescription: finalResult.content,
          metaTitle: finalResult.metaTitle || prev.metaTitle,
          metaDescription: finalResult.metaDescription,
        }));
        setResponse(prev => prev + chunk);
      }


      // const res = await dispatch(fetchAIPrompt(payload)).unwrap();

      // // ✅ Ensure res is the actual fetch Response object (not JSON-parsed yet)
      // const reader = res.getReader();
      // const decoder = new TextDecoder("utf-8");

      // let fullContent = "";
      // let partial = "";

      // while (true) {
      //   const { done, value } = await reader.read();
      //   if (done) break;

      //   // decode current chunk
      //   const chunk = decoder.decode(value, { stream: true });

      //   fullContent += chunk;
      //   partial += chunk;

      //   // optional: update in real-time if you detect a sentence end
      //   if (/[.\n!?]$/.test(partial)) {
      //     const result = convertAndExtractMeta(fullContent);
      //     setFormData((prev) => ({
      //       ...prev,
      //       productDescription: result.content,
      //       metaTitle: result.metaTitle || prev.metaTitle,
      //       metaDescription: result.metaDescription,
      //     }));
      //     partial = ""; // reset buffer
      //   }
      // }
      // final parse
      const finalResult = convertAndExtractMeta(fullContent);
      setFormData((prev) => ({
        ...prev,
        productDescription: finalResult.content,
        metaTitle: finalResult.metaTitle || prev.metaTitle,
        metaDescription: finalResult.metaDescription,
      }));

    } catch (error) {
      setFormData(prev => ({
        ...prev,
        productDescription: "Error generating description. Please try again.",
      }));
    } finally {
      setPromptIsLoading(false);
    }
  }, [mainWebCategoryName]);

  const promptDataRef = useRef({});


  useEffect(() => {
    const promptPass = {
      BrandName: formData?.brandName,
      StrainType: formData?.strainType,
      productName: formData?.productName,
      categoryName: formData?.categoryName,
      concatProductWeight: `${formData?.productWeightValue || ''}${formData?.productWeightUnit || ''}`,
      concatThc: `${formData?.thcValue || ''}${formData?.thcUnit || ''}`,
      categoryType: mainCategoryType ? mainCategoryType : "-"
    }
    promptDataRef.current = promptPass;
  }, [formData])

  const isAiDisabled =
    isPromptLoading ||
    !mainWebCategoryName ||
    !formData?.productName ||
    !formData?.categoryName ||
    !formData?.brandName ||
    !formData?.strainType ||
    !formData?.productWeightUnit ||
    !formData?.productWeightValue ||
    !formData?.thcUnit ||
    !formData?.thcValue;

  const isDisabledAccessories = isPromptLoading ||
    !mainWebCategoryName ||
    !formData?.productName ||
    !formData?.categoryName ||
    !formData?.brandName


  // const [input, setInput] = useState("create dummy data");
  // const [response, setResponse] = useState("");
  // const sendMessage = async () => {
  //   setResponse("");
  //   const payload = { prompt: input };
  //   const res = await dispatch(fetchAIPrompt(payload)).unwrap()

  //   if (!res.body) {
  //     return;
  //   }

  //   const reader = res.body.getReader();
  //   const decoder = new TextDecoder("utf-8");

  //   while (true) {
  //     const { done, value } = await reader.read();
  //     if (done) break;
  //     const chunk = decoder.decode(value, { stream: true });
  //     setResponse((prev) => prev + chunk);
  //   }

  // };
  useEffect(() => {
    if (!productId) {
      console.log("skuuu", formData?.sku, productId, generateSku());
      setFormData(prev => ({
        ...prev,
        sku: generateSku()
      }))


    }

  }, [])
  return (
    <TabContext value={currentTab}>
      <TabPanel value="products" sx={{ p: 0 }}>
        <form className={classes.form} onSubmit={handleSubmit} style={{ marginTop: 0 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={2}>
            {/* <Link to='/products/add'> */}
            <Box display='flex' alignItems='center' color='text.main' lineHeight={1}>
              <IconButton onClick={() => navigate(-1)}>
                <AngleRightIcon fontSize='14px' />
              </IconButton>
              <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                {/* <Typography variant='h4' fontWeight="semibold" color="secondary"> */}
                {productId ? "Update Product" : "Add Product"}
              </Typography>
            </Box>

            {/* </Link> */}
            <Box display="flex" alignItems="center" gap={1.25}>
              <Typography variant='h5' fontWeight="semibold" color="secondary">Status</Typography>
              <Stack direction="row" alignItems="center" gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor="#F2F3F7">
                <MDButton
                  sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                  type='button'
                  onClick={() => setFormData({ ...formData, status: 'active' })}
                  variant={formData?.status === 'active' ? 'contained' : 'text'}
                  color={formData?.status === 'active' ? 'success' : 'dark'}
                  size="small"
                >
                  Active
                </MDButton>
                <MDButton
                  sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                  type='button'
                  onClick={() => setFormData({ ...formData, status: 'inactive' })}
                  variant={formData?.status !== 'active' ? 'contained' : 'text'}
                  color={formData?.status !== 'active' ? 'error' : 'dark'}
                  size="small"
                >
                  Inactive
                </MDButton>
              </Stack>
            </Box>
          </Stack>



          <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>

            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Product Images</Typography>
            <Stack direction="row" flexWrap="wrap" gap={1.25} mb={4.5}>
              {
                formData?.productImages?.length > 0 && <>
                  <ImageDragger images={formData?.productImages} imageDragHandler={(updatedImages => setFormData({ ...formData, productImages: updatedImages }))} removeImageHandler={removeImageHandler} />
                </>
              }
              <label htmlFor='product-image-input'>
                <Box bgcolor="#F1F1F1" display="flex" alignItems="center" justifyContent="center" flexDirection="column" minWidth="160px" minHeight="160px" borderRadius="20px" p={2} sx={{ cursor: isAllowProductUpload ? 'pointer' : 'not-allowed' }}>
                  {
                    isUploading ? <CircularProgress size={32} color='primary' sx={circularProgressIcon} /> : <Typography variant='body2' fontWeight="medium" textAlign="center">+<br />  Add {formData?.productImages?.length > 0 && 'More'}</Typography>
                  }
                </Box>
              </label>
              <TextField
                id="product-image-input"
                type='file'
                name='productImageFile'
                disabled={!isAllowProductUpload}
                onChange={productImageUploadHandler}
                sx={{ display: 'none' }}
              />
              {Boolean(errors?.productImages) &&
                <Box display="inline-flex" width="100%">
                  <Alert severity="error">{errors?.productImages}</Alert>
                </Box>
              }
            </Stack>

            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Product Info</Typography>
            <Grid container spacing={2.5} mb={4.5}>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Product Name*"
                  className="form-input"
                  fullWidth
                  placeholder="Product Name"
                  name="productName"
                  value={formData.productName}
                  onChange={handleChange}
                  error={Boolean(errors?.productName)}
                  helperText={errors?.productName}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Retail Price ($)"
                  className="form-input"
                  fullWidth
                  placeholder='Retail Price ($)'
                  name="unitPrice"
                  value={formData.unitPrice || ''}
                  onChange={handleChange}
                  type='number'
                  error={Boolean(errors?.unitPrice)}
                  helperText={errors?.unitPrice ? 'Retail Price is required' : ''}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Sale Price ($)"
                  className="form-input"
                  fullWidth
                  placeholder='Sale Price ($)'
                  name="salePrice"
                  value={formData.salePrice || ''}
                  onChange={handleChange}
                  type='number'
                  error={Boolean(errors?.salePrice)}
                  helperText={errors?.salePrice}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Category Name</InputLabel>
                  <Select
                    className="form-select"
                    error={Boolean(errors?.categoryName)}
                    onChange={handleChange} label="Category Name" name="categoryName" value={formData.categoryName}>
                    {
                      mainCategories?.result?.map((category => {
                        return <MenuItem key={category.categoryName} value={category.categoryName}>{category?.categoryName}</MenuItem>;
                      }))
                    }
                  </Select>
                  {Boolean(errors?.categoryName) && <FormHelperText error>{errors?.categoryName}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Brand Name</InputLabel>
                  <Select
                    className="form-select"
                    error={Boolean(errors?.brandName)}
                    onChange={handleChange} label="Brand Name" name="brandName" value={formData.brandName}>
                    {
                      brandsData?.brands?.map((brandsData => {
                        return <MenuItem key={brandsData.brandName} value={brandsData.brandName}>{brandsData?.brandName}</MenuItem>;
                      }))
                    }
                  </Select>
                  {Boolean(errors?.brandName) && <FormHelperText error>{errors?.brandName}</FormHelperText>}

                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  label="Created By"
                  className="form-input created-by"
                  name="createdBy"
                  fullWidth
                  disabled
                  value={formData?.createdBy || ''}
                  onChange={handleChange}
                  error={Boolean(errors?.createdBy)}
                  helperText={errors?.createdBy}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle fontSize='medium' color='secondary' />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Tags</InputLabel>
                  <Select
                    className="form-select"
                    multiple
                    value={formData?.tags || []}
                    label="Tags"
                    error={Boolean(errors?.tags)}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(tag => (
                          <Chip
                            key={tag}
                            label={tag}
                            size="small"
                            onMouseDown={e => e.stopPropagation()}
                            onDelete={() => setFormData(prev => ({ ...prev, tags: prev.tags.filter(t => t !== tag) }))}
                          />
                        ))}
                      </Box>
                    )}
                    onClose={() => setTagSearch('')}
                    MenuProps={{ autoFocus: false }}
                  >
                    <ListSubheader sx={{ pt: 1, pb: 0 }}>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Search tags..."
                        value={tagSearch}
                        onChange={e => setTagSearch(e.target.value)}
                        onKeyDown={e => e.stopPropagation()}
                        autoFocus
                      />
                    </ListSubheader>
                    <MenuItem className="color-blue" onClick={handleAddNewTagModal}>
                      + Add New Tag
                    </MenuItem>
                    {tagList
                      .filter(item => !tagSearch || item.toLowerCase().includes(tagSearch.toLowerCase()))
                      .map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item}
                          onClick={() => {
                            setFormData(prev => {
                              const already = prev.tags.includes(item);
                              return {
                                ...prev,
                                tags: already ? prev.tags.filter(t => t !== item) : [...prev.tags, item]
                              };
                            });
                          }}
                        >
                          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                            <Typography variant="body2" noWrap>{item}</Typography>
                            <IconButton
                              className="remove-btn"
                              size="small"
                              onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                dispatch(openCustomModalDialog({
                                  modalData: { deleteHandler: tagDeleteHandler, deleteId: item, deleteType: 'tag' },
                                  modal: 'DELETE_MODAL'
                                }));
                              }}
                              onMouseDown={e => { e.stopPropagation(); e.preventDefault(); }}
                            >
                              <DeleteIcon width='15px' height='15px' color='#FD4438' />
                            </IconButton>
                          </Stack>
                        </MenuItem>
                      ))
                    }
                  </Select>
                  {Boolean(errors?.tags) && <FormHelperText error>{errors?.tags}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Strain Type</InputLabel>
                  <Select
                    className="form-select"
                    error={Boolean(errors?.strainType)}
                    onChange={handleChange} label="Strain Type" name="strainType" value={formData.strainType}>
                    {[
                      { name: 'Indica', value: 'Indica' },
                      { name: 'Indica / Hybrid', value: 'Indica-dominant Hybrid' },
                      { name: 'Hybrid', value: 'Hybrid' },
                      { name: 'Sativa / Hybrid', value: 'Sativa-dominant Hybrid' },
                      { name: 'Sativa', value: 'Sativa' },
                    ].map((strain) => (
                      <MenuItem key={strain.value} value={strain.value}>{strain.name}</MenuItem>
                    ))}
                  </Select>
                  {Boolean(errors?.strainType) && <FormHelperText error>{errors?.strainType}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>Product Weight (Unit)</InputLabel>
                  <Select
                    className="form-select"
                    error={Boolean(errors?.productWeightUnit)}
                    value={formData?.productWeightUnit || ''} onChange={handleChange} label="Product Weight (unit)" name="productWeightUnit" >
                    <MenuItem value='g'>Gram (g)</MenuItem>
                    <MenuItem value='mg'>MilliGrams (mg)</MenuItem>
                  </Select>
                  {Boolean(errors?.productWeightUnit) && <FormHelperText error>{errors?.productWeightUnit}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <TextField
                    className="form-input"
                    label="Product Weight (value)"
                    name="productWeightValue"
                    value={formData?.productWeightValue || ''}
                    onChange={handleChange}
                    type='number'
                    error={Boolean(errors?.productWeightValue)}
                    helperText={errors?.productWeightValue}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl fullWidth>
                  <InputLabel>THC (unit)</InputLabel>
                  <Select
                    className="form-select"
                    error={Boolean(errors?.thcUnit)}
                    value={formData?.thcUnit || ''} onChange={handleChange} label="THC (unit)" name="thcUnit" >
                    <MenuItem value="%">Percentage (%)</MenuItem>
                    <MenuItem value='mg'>MilliGrams (mg)</MenuItem>
                  </Select>
                  {Boolean(errors?.thcUnit) && <FormHelperText error>{errors?.thcUnit}</FormHelperText>}

                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  className="form-input"
                  fullWidth
                  label="THC (value)"
                  name="thcValue"
                  value={formData.thcValue || ''}
                  onChange={handleChange}
                  type='number'
                  error={Boolean(errors?.thcValue)}
                  helperText={errors?.thcValue}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  className="form-input"
                  fullWidth
                  label="SKU"
                  disabled
                  name="sku"
                  value={formData.sku}
                  onChange={handleChange}
                  error={Boolean(errors?.sku)}
                  helperText={errors?.sku}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  className="form-input"
                  fullWidth
                  label="Product Slug"
                  name="productSlug"
                  value={productSlugData}
                  onChange={handleChangeSlug}
                />
              </Grid>
            </Grid>

            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Other Info</Typography>
            {/* <Box display="flex" flexWrap="wrap" columnGap={4} mb={2.5}>
              <FormGroup>
                <FormControlLabel control={<Switch checked={formData?.isBestSeller} onChange={(e) => setFormData({ ...formData, isBestSeller: e.target.checked })} />} label="Best Seller" />
              </FormGroup>
              <FormGroup>
                <FormControlLabel control={<Switch checked={formData?.isFeatured} onChange={(e) => setFormData({ ...formData, isFeatured: e.target.checked })} />} label="Featured Product" />
              </FormGroup>
              <FormGroup>
                <FormControlLabel control={<Switch checked={formData?.isCustFav} onChange={(e) => setFormData({ ...formData, isCustFav: e.target.checked })} />} label="Customer Favouite" />
              </FormGroup>
            </Box> */}
            <FormGroup sx={{ alignItems: 'start' }}>
              <FormControlLabel control={<Switch checked={formData?.ingredientStatus} onChange={(e) => setFormData({ ...formData, ingredientStatus: e.target.checked })} />} label="Show Ingredients" />
            </FormGroup>

            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <CommonQuillEditor
                  style={true} height={"200px"}
                  value={formData?.ingredients || ''}
                  onChange={(value) => setFormData({ ...formData, ingredients: value })}
                />
                {Boolean(errors?.ingredients) && <FormHelperText error>{errors?.ingredients}</FormHelperText>}
              </Grid>

              {formData.categoryName &&
                <Grid item xs={12}>
                  <FormGroup sx={{ alignItems: 'start' }}>
                    <FormControlLabel control={<Switch checked={formData?.instructionStatus} onChange={(e) => setFormData({ ...formData, instructionStatus: e.target.checked })} />} label="Show Instructions" />
                  </FormGroup>
                </Grid>
              }
              {formData.categoryName &&
                <Grid item xs={12}>
                  <TextField
                    label="Instructions"
                    value={convertHtmlToText(formData.instructions)}
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    name='metaDescription'
                    className="form-input"
                    disabled
                  />
                </Grid>
              }
              {/* 
              <Grid item xs={12}>
                <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} my={2}>
                  <Typography variant="body2" fontWeight="medium" color={grey[600]} mb={1}>Product Description</Typography>
                  <MDButton
                    sx={{ minWidth: '160px' }}
                    onClick={handleGenerate}
                    disabled={!mainWebCategoryName || isPromptLoading}
                    color="primary"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    {isPromptLoading ? "Generating..." : "Generate Description"}
                  </MDButton>
                </Box>
                <CommonQuillEditor
                  value={formatAIResponse(aiResponse)}
                />
              </Grid> */}
              <Grid item xs={12}>

                <Box style={{ display: 'flex', justifyContent: 'end', gap: "1rem", alignItems: 'center' }} my={2}>
                  {
                    // (formData?.metaTitle || formData?.metaDescription || formData?.description )&&
                    <>
                      {mainWebCategoryName.toLowerCase() === 'accessories' ? (
                        <Box display="inline-flex" width="100%">
                          <Alert severity="error">{META_FIELD_ACCESSORIES_VALIDATION_ERROR_MSG}</Alert>
                        </Box>
                      )
                        :
                        <Box display="inline-flex" width="100%" className="product-info">
                          <Alert severity="error">{META_FIELD_VALIDATION_ERROR_MSG}</Alert>
                        </Box>
                      }
                    </>
                  }
                  {/* <Typography variant="body2" fontWeight="medium" color="secondary">
                    Generate Meta Content
                  </Typography> */}

                  <MDButton
                    variant="contained"
                    color="primary"
                    // size="small"
                    onClick={handleGenerate}
                    disabled={mainWebCategoryName.toLowerCase() === 'accessories' ? isDisabledAccessories : isAiDisabled}
                    // disabled={isPromptLoading || !mainWebCategoryName || !formData?.productName}
                    startIcon={!isPromptLoading && <SmartToyIcon />} // Show icon only when not loading
                    style={{ minWidth: "160px" }}
                  >
                    {isPromptLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      'Generate'
                    )}
                  </MDButton>
                </Box>

                <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Meta Properties</Typography>
                <Grid container spacing={2.5} mb={4.5}>
                  <StiloForm
                    isHeading={false}
                    isBodyText={false}
                    errors={errors}
                    strainData={formData}
                    setStrainData={setFormData}
                  />
                </Grid>
                <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Body Text</Typography>
                {/* <CommonQuillEditor
                  value={formatAIResponse(formData?.productDescription)}

                  // value={formatAIResponse(aiResponse)}
                  onChange={(value) => setFormData({ ...formData, productDescription: value })}

                /> */}
                <CommonQuillEditor
                  style={true} height={"300px"}
                  onChange={(value) => setFormData({ ...formData, productDescription: value })}
                  value={formData?.productDescription}
                  allowHeading={false}
                />
                {Boolean(errors?.productDescription) && <FormHelperText error>{errors?.productDescription}</FormHelperText>}
              </Grid>

            </Grid>
          </Card>

          {/********************** Save, Cancel Buttons **********************/}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} mb={2}>
                <MDButton
                  sx={{ minWidth: '160px' }}
                  type='submit'
                  variant='contained'
                  color='primary'
                  loading={isUpdating}
                  disabled={isUpdating}
                >
                  {productId ? 'Update' : 'Save'}
                </MDButton>

                {
                  productId && <MDButton
                    sx={{ minWidth: '160px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
                    type='button'
                    variant='contained'
                    color='error'
                    onClick={() => {
                      dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: productId }, modal: 'DELETE_MODAL' }));
                    }}
                  >
                    Delete
                  </MDButton>
                }

                <MDButton
                  sx={{ minWidth: '160px' }}
                  type='button'
                  variant='outlined'
                  color='dark'
                  onClick={() => navigate('/products')}
                >
                  Cancel
                </MDButton>
              </Stack>
            </Grid>
          </Grid>

        </form>
      </TabPanel>

      <TabPanel value='inventory' sx={{ p: 0 }}>
        <InventroyTable productId={productId} batchHandler={batchHandler} totalProduct={singleProduct?.productDetails
          ?.totalQuantity} />
      </TabPanel>

      <TabPanel value="batches" sx={{ p: 0 }}>
        {
          isBatchAddOpen ? <>
            <Card sx={{ p: 3, mb: 4, borderRadius: 2.5, boxShadow: 'none' }}>
              <Typography variant='h4' fontWeight="semibold" color="secondary" mb={3.5}>{editBatch?.productBatchId ? 'Update' : 'Add'} Batch</Typography>

              <form className={classes.form} onSubmit={handleBatchProductSubmit}>
                <Grid container columnSpacing={3} rowSpacing={5} mb={4.5}>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth>
                      <DatePicker
                        label="Purchase Date"
                        error={Boolean(errors?.purchaseDate)}
                        name="purchaseDate"
                        onChange={(value) => {
                          setFormData({ ...formData, purchaseDate: value });
                        }}
                        value={formData?.purchaseDate || null}
                        slots={{
                          openPickerIcon: CalendarIcon
                        }}
                        slotProps={{
                          openPickerButton: {
                            color: 'secondary',
                          },
                        }}
                        format='MM/DD/YYYY'
                      />
                      {Boolean(errors?.purchaseDate) && <FormHelperText error>{errors?.purchaseDate}</FormHelperText>}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth>
                      <DatePicker
                        label="Expiration Date"
                        name="expirationDate"
                        onChange={(value) => {
                          setFormData({ ...formData, expirationDate: value });
                        }}
                        value={formData?.expirationDate || null}
                        slots={{
                          openPickerIcon: CalendarIcon
                        }}
                        slotProps={{
                          openPickerButton: {
                            color: 'secondary',
                          },
                        }}
                        minDate={formData?.purchaseDate ? formData?.purchaseDate : ''}
                        format='MM/DD/YYYY'
                      />
                      {Boolean(errors?.expirationDate) && <FormHelperText error>{errors?.expirationDate}</FormHelperText>}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField className="form-input" value={formData?.uniqueNumber || ''} label="Unique Number" onChange={handleChange} name="uniqueNumber" fullWidth
                      error={Boolean(errors?.uniqueNumber)}
                      helperText={errors?.uniqueNumber}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select error={Boolean(errors?.batchStatus)} label="Status" className="form-select" name="batchStatus" value={formData.batchStatus?.toLowerCase() || ''} onChange={handleChange}>
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                      </Select>
                      {Boolean(errors?.batchStatus) && <FormHelperText error>{errors?.batchStatus}</FormHelperText>}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField className="form-input" type='text' value={formData?.purchaseQuantity || ''} label="Purchase Quantity " onChange={handleChange} name="purchaseQuantity" fullWidth
                      error={Boolean(errors?.purchaseQuantity)}
                      helperText={errors?.purchaseQuantity}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField className="form-input" type='text' label="Current Quantity" value={formData?.currentQuantity || ''} onChange={handleChange} name="currentQuantity" fullWidth
                      error={Boolean(errors?.currentQuantity)}
                      helperText={errors?.currentQuantity}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField className="form-input" type='number' label="Unit Cost" value={formData?.unitCost || ''} name="unitCost" fullWidth onChange={handleChange}
                      error={Boolean(errors?.unitCost)}
                      helperText={errors?.unitCost}
                    />
                  </Grid>
                </Grid>
              </form>
            </Card>

            {/********************** Save, Cancel Buttons **********************/}
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2}>
                  <MDButton
                    sx={{ minWidth: '160px' }}
                    type='submit'
                    variant='contained'
                    color='primary'
                    loading={loading || isUpdating}
                    disabled={isUpdating || loading}
                  >
                    {
                      editBatch?.productBatchId ? 'Update' : 'Save'
                    }
                  </MDButton>
                  {
                    editBatch?.productBatchId && <MDButton
                      sx={{ minWidth: '160px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
                      type='button'
                      variant='contained'
                      color='error'
                      onClick={() => {
                        dispatch(openCustomModalDialog({ modalData: { deleteHandler: deleteBatchHandler, deleteId: { productId: productId, productBatchId: editBatch?.productBatchId } }, modal: 'DELETE_MODAL' }));
                      }}
                    >
                      Delete
                    </MDButton>
                  }
                  <MDButton
                    sx={{ minWidth: '160px' }}
                    type='button'
                    variant='outlined'
                    color='dark'
                    onClick={batchHandler}
                  >
                    Cancel
                  </MDButton>
                </Stack>
              </Grid>
            </Grid>

          </> : <BatchTable productId={productId} batchHandler={batchHandler} editBatchHandler={editBatchHandler} />
        }
      </TabPanel>

      <TabPanel value='terpenoids' sx={{ p: 0 }}>
        {
          isTerpeneAddOpen ? <AddProductTerpenoid productId={productId} terpenoidHandler={terpenoidHandler} editTerpenoidHandler={editTerpenoidHandler} editTerpenoid={editTerpenoid} resetEditTerpenoid={() => {
            setEditTerpenoid({});
            setIsTerpeneAddOpen(false);
          }} /> : <ProductTerpenoids terpenoidHandler={terpenoidHandler} editTerpenoidHandler={editTerpenoidHandler} />
        }
      </TabPanel>

      <TabPanel value='activity_logs' sx={{ p: 0 }}>
        <ProductActivityLogs />
      </TabPanel>

    </TabContext>
  );
};

export default AddProductForm;